import { createSlice } from "@reduxjs/toolkit";

const initialState ={
isloading:false,
status:"",
message:"",
userroledata:[]
};

const userRoleSlice = createSlice({
    name:"userRoleCreate",
    initialState,
    reducers:{
        createRolePending:(state,action) => {
            state.isloading=true;
        },
        createRoleSuccess:(state,{payload}) => {
            state.isloading=false;
            state.status="success";
            state.message=payload.message;
            state.userroledata=payload;

        },
        createRoleFail:(state,{payload}) => {
            state.isloading=false;
            state.status="fail";
            console.log('slice '+payload);
            state.message='This User role is already existing in the database'; //payload.message
        }


    }
});

const {reducer,actions} = userRoleSlice;
export const{createRolePending,createRoleSuccess,createRoleFail}=actions;
export default reducer;

